<template>
  <v-card flat :loading="loading">
    <FullCalendar
      ref="fullCalendar"
      class="calendar"
      :options="calendarOptions"
    />
    <v-dialog
      max-width="450px"
      v-model="selectedOpen"
      :close-on-content-click="false"
    >
      <v-card flat>
        <v-toolbar :color="selectedEvent.backgroundColor" dark dense>
          <v-toolbar-title v-html="selectedEvent.title"></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-template v-if="!selectedEvent.surat_id && isSekpri && pimpinan">
            <v-btn icon @click="editEvent">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="deleteDialogVisible = true">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-template>
        </v-toolbar>
        <v-card-text class="event">
          <v-simple-table dense>
            <template v-slot:default>
              <tr>
                <th>Undangan dari</th>
                <td>{{ selectedEvent.from }}</td>
              </tr>
              <tr>
                <th>Perihal</th>
                <td>{{ selectedEvent.title }}</td>
              </tr>
              <tr>
                <th>Lokasi</th>
                <td>{{ selectedEvent.tempat }}</td>
              </tr>
              <tr>
                <th>Waktu</th>
                <td>
                  {{ selectedEvent.start | dateTime }}
                </td>
              </tr>
              <tr v-if="selectedEvent.end">
                <th></th>
                <td>
                  <strong>s.d.</strong> {{ selectedEvent.end | dateTime }}
                </td>
              </tr>
              <tr v-if="!selectedEvent.surat_id">
                <td colspan="2">
                  <br />
                  <v-alert text dense outlined color="blue">
                    <span>
                      <small>Agenda ini ditambahkan oleh Sekretaris</small>
                    </span>
                  </v-alert>
                </td>
              </tr>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialogVisible"
      transition="dialog-bottom-transition"
      width="400px"
      :persistent="deleting"
    >
      <v-card :loading="deleting">
        <v-card-title>
          Yakin Hapus Agenda Ini?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialogVisible = false"
          >
            Tidak
          </v-btn>
          <v-btn color="error darken-1" @click="deleteEvent" text>
            Hapus Agenda
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { deleteAgenda, getAgendas } from '@/services/agenda'
import moment from 'moment'
import { mapGetters } from 'vuex'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  props: {
    pimpinan: { type: Boolean, default: false }
  },
  components: {
    FullCalendar
  },
  data: function() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        customButtons: {
          prevMonth: {
            icon: 'chevron-left',
            click: () => this.prev()
          },
          nextMonth: {
            icon: 'chevron-right',
            click: () => this.next()
          }
        },
        headerToolbar: {
          left: 'prevMonth,nextMonth',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        initialView: 'dayGridMonth',
        events: [],
        locale: 'id',
        buttonText: {
          today: 'Hari Ini',
          month: 'Bulan',
          week: 'Minggu',
          day: 'Hari',
          list: 'Daftar'
        },
        eventClick: this.showEvent
      },
      loading: false,
      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,
      start: {
        date: moment()
          .startOf('month')
          .format('YYYY-MM-DD')
      },
      end: null,
      current: moment(),
      deleteDialogVisible: false,
      deleting: false
    }
  },
  watch: {
    pimpinan() {
      this.load(true)
    },
    current: function() {
      this.load()
    }
  },
  computed: {
    ...mapGetters(['isSekpri'])
  },
  methods: {
    load(refresh = false) {
      const vm = this
      this.loading = true
      getAgendas(
        this.current.format('YYYY'),
        this.current.format('M'),
        this.pimpinan ? 1 : 0
      )
        .then(data => {
          let _events = []
          if (!refresh) {
            let { events: currentEvents } = vm.calendarOptions
            currentEvents = currentEvents.filter(event => {
              const findEvent = data.findIndex(e => e.id === event.id)
              return findEvent >= 0 ? false : true
            })
            _events = [...currentEvents, ...data]
          } else {
            _events = data
          }
          vm.calendarOptions.events = _events
        })
        .finally(() => (this.loading = false))
    },
    async deleteEvent() {
      this.deleting = true
      await deleteAgenda(this.selectedEvent.id)
      this.deleteDialogVisible = false
      this.selectedOpen = false
      this.deleting = false
      this.load(true)
    },
    getEventColor(event) {
      return event.color
    },
    prev() {
      const calendar = this.$refs.fullCalendar.getApi()
      calendar.prev()
      this.current = moment(calendar.getDate())
    },
    next() {
      const calendar = this.$refs.fullCalendar.getApi()
      calendar.next()
      this.current = moment(calendar.getDate())
    },
    showEvent(info) {
      let { extendedProps, ...event } = info.event.toPlainObject()
      event = {
        ...event,
        ...extendedProps
      }
      this.selectedEvent = event
      this.selectedOpen = true
    },
    editEvent() {
      this.$emit('edit', this.selectedEvent)
      this.selectedOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar {
  margin: 1rem;
}
.event {
  padding: 0.75rem 0.5rem !important;
}
</style>
